import React from 'react'
import { TextField, InputAdornment, IconButton } from '@mui/material'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { TextBody } from 'components'
import { AuthInputContainer } from '../Auth.styled'

const AuthPasswordInput = props => {
  const {
    password,
    handleInputChange,
    showPassword,
    handlePasswordVisibility,
    error,
    ...rest
  } = props

  return (
    <AuthInputContainer mb="0.5rem">
      <TextBody variant="subtitle" fontWeight={600}>
        Password
      </TextBody>
      <TextField
        name="password"
        placeholder="Enter your password..."
        type={showPassword ? 'text' : 'password'}
        fullWidth
        margin="normal"
        variant="outlined"
        value={password}
        onChange={handleInputChange}
        error={!!error}
        helperText={error}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={handlePasswordVisibility} edge="end">
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          )
        }}
        {...rest}
      />
    </AuthInputContainer>
  )
}

export default AuthPasswordInput
